module.exports = __webpack_public_path__ + "img/lexisnexis.1342475d.svg";